import Vue from 'vue'
import vuetify from './plugins/vuetify'
import { VApp } from "vuetify/lib";
import VueRouter from 'vue-router'
import axios from "axios";
import VueAxios from 'vue-axios'
import vueCustomElement from 'vue-custom-element'
import Catalogue from '@/components/DatasheetCatalogue.vue'

Vue.prototype.$prodPrefix = process.env.VUE_APP_FRONTEND_BASE_URL;
axios.defaults.baseURL = process.env.VUE_APP_BACKEND_BASE_URL

Vue.use(vueCustomElement);
Vue.use(VueRouter);
Vue.use(VueAxios, axios);
  
// Catalogue component
Vue.customElement('iupac-catalogue-custom-element', {
    vuetify: vuetify,
    router: new VueRouter({
        mode: "hash",
        routes: [
            {
                path: '/catalogue/categories/:code',
                component: Catalogue,
            },
            {
                path: '/catalogue/classifications/:code',
                component: Catalogue,
            }
        ]
    }),
    components: { VApp },
    template: `<v-app id='app'><router-view></router-view></v-app>`
})